import { computed, Directive, inject } from '@angular/core';
import { FormPickerComponent } from '@core/components';
import { RequestService } from '@core/services/request/request.service';
import { toObservable } from '@angular/core/rxjs-interop';

@Directive({
  selector: 'x-form-picker[xAttachActualDeliveryAddresses]',
  standalone: true,
})
export class AttachActualDeliveryAddressesDirective {
  private readonly component = inject(FormPickerComponent);
  public readonly requestService = inject(RequestService);
  public $selectedRequestsAddresses = computed(() =>
    this.requestService
      .selectedRequests()
      .map(request => request.deliveryAddress)
      .filter(Boolean)
      .filter((address, index, self) => self.indexOf(address) === index),
  );

  constructor() {
    this.component.items$ = toObservable(this.$selectedRequestsAddresses);
  }
}
